module.exports = "/assets/images/a34f0503ab89c45acb177ff3d60c3e3e.jpg";